import(/* webpackMode: "eager" */ "/codebuild/output/src3725343678/src/src/app/global-error.tsx");
